import { Modal, Avatar, Text, Group, ScrollArea, Stack } from "@mantine/core";

const getInitials = (name) => {
  if (!name) return "U";
  const names = name.split(" ");
  if (names.length > 1) {
    return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

export function LikersModal({ isOpen, setIsOpen, likers, variantName }) {
  return (
    <Modal
      opened={isOpen}
      onClose={() => setIsOpen(false)}
      title={`Likes for "${variantName}"`}
      centered
    >
      <Text size="sm" c="dimmed" mb="md">
        {likers.length > 0 ? "Users who liked this variant." : "No one has liked this variant yet."}
      </Text>
      {likers.length > 0 && (
        <ScrollArea h={200}>
          <Stack gap="md">
            {likers.map((liker) => (
              <Group key={liker.id}>
                <Avatar radius="xl" color="cyan">
                  {getInitials(liker.name)}
                </Avatar>
                <Text size="sm" fw={500}>{liker.name}</Text>
              </Group>
            ))}
          </Stack>
        </ScrollArea>
      )}
    </Modal>
  );
}